import styled, { css } from 'styled-components'

export const StyledSizeSelector = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.border};
  user-select: none;

  button {
    &.open {
      svg {
        transform: rotate(90deg);
      }
    }
    svg {
      transition: transform 0.3s ease;
      transform: rotate(-90deg);
    }
  }
`

export const StyledButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1.3rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.background};
  border: none;

  & > .size-selected-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
    max-height: 1.4rem;
    overflow: hidden;

    * {
      font-size: 1.4rem;
    }
  }
`

export const StyledSizeList = styled.ul<{ opened: boolean }>`
  display: ${({ opened }) => (opened ? 'block' : 'none')};
  position: absolute;
  left: -1px;
  right: -1px;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-top: none;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 10;
  max-height: 17rem;
  overflow-y: auto;
  top: calc(100% + 1px);

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #d9d9d9;
  }

  &::-webkit-scrollbar-thumb {
    background: #313332;
  }
`

export const StyledSizeOption = styled.li<{ isOutOfStock: boolean }>`
  padding: 12px 15px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  align-items: center;
  transition: background-color 0.1s linear;

  &:hover {
    background-color: #d9d9d9;
  }

  ${(props) =>
    props.isOutOfStock &&
    css`
      color: ${({ theme }) => theme.colors.text.light};
      cursor: not-allowed;
    `}
`
